var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 97,
    viewBox: "0 0 98 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.4458 4.28348L68.9681 0L66.4904 4.28348L64.0127 8.58796H66.5744V62.0895H71.3618V8.58796H73.9235L71.4458 4.28348Z",
    fill: "url(#paint0_linear_3307_660)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6074 20.115L79.1297 15.8315L76.652 20.115L74.1743 24.3985H76.736V68.9551H81.5234V24.3985H84.0851L81.6074 20.115Z",
    fill: "url(#paint1_linear_3307_660)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.409 13.0396V50.478L14.1017 76.5779L12.4429 75.0661V40.0633L61.409 13.0396Z",
    fill: "url(#paint2_linear_3307_660)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4351 16.3564V49.3225L59.3511 49.3645L47.1725 56.0837L14.3955 74.1835V41.2384L17.1672 39.7056L29.3457 32.9864L31.0045 32.0626L35.498 29.5849L59.4351 16.3564Z",
    fill: "url(#paint3_linear_3307_660)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6579 66.6876L45.8493 94.3412L42.5946 94.2363L17.8806 80.5249L18.1326 80.2729L14.1011 76.5774L61.4084 50.4565L66.0488 53.0392L69.1564 54.761L74.4058 57.6587L77.4924 59.3805L82.7418 62.2991L85.8284 64.0209L90.6579 66.6876Z",
    fill: "url(#paint4_linear_3307_660)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4961 77.5031L61.4097 52.7051L86.7746 66.7944L44.3387 92.9782L16.4961 77.5031Z",
    fill: "url(#paint5_linear_3307_660)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0518 77.837L66.8261 69.522L74.9731 74.0364L61.3668 82.4354L53.0518 77.837Z",
    fill: "url(#paint6_linear_3307_660)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5954 94.2367L40.5797 94.1737L17.1885 81.1973L17.8814 80.5254L42.5954 94.2367Z",
    fill: "url(#paint7_linear_3307_660)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6592 66.6885V67.9063L47.5094 94.3841L45.8506 94.3421L90.6592 66.6885Z",
    fill: "url(#paint8_linear_3307_660)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M59.3504 49.3653L47.1719 56.0845L17.1665 39.7065L29.345 32.9873L59.3504 49.3653Z",
    fill: "url(#paint9_linear_3307_660)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M59.4359 42.6464V46.8878V47.6018L31.0054 32.0636L35.4988 29.5859L59.4359 42.6464Z",
    fill: "url(#paint10_linear_3307_660)"
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3331 92.8721C26.7635 92.8721 10.9104 77.019 10.9104 57.4703C10.9104 37.9007 26.7635 22.0476 46.3331 22.0476C46.921 22.0476 47.488 22.0686 48.0759 22.0896L53.4513 19.129C51.1415 18.688 48.7688 18.478 46.3331 18.478C24.7897 18.478 7.34082 35.9269 7.34082 57.4703C7.34082 78.9927 24.7897 96.4416 46.3331 96.4416C61.3043 96.4416 74.3017 88.0006 80.8319 75.6121L73.5668 80.0636C67.0786 87.8957 57.2938 92.8721 46.3331 92.8721Z",
    fill: "url(#paint11_linear_3307_660)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3307_660",
    x1: 263.53,
    y1: -21.2377,
    x2: 263.53,
    y2: 61.7067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAD4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#77007C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3307_660",
    x1: 221.629,
    y1: 11.3515,
    x2: 221.629,
    y2: 74.3469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAD4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#77007C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3307_660",
    x1: 12.4368,
    y1: 13.0387,
    x2: 61.4043,
    y2: 13.0387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#461885"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA51E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3307_660",
    x1: 95.6387,
    y1: 52.7843,
    x2: 44.7529,
    y2: 103.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAD4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#77007C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3307_660",
    x1: 14.0988,
    y1: 50.4582,
    x2: 90.6534,
    y2: 50.4582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#461885"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA51E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3307_660",
    x1: 92.1533,
    y1: 69.9474,
    x2: 49.7058,
    y2: 103.681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA51E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461885"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3307_660",
    x1: 48.9184,
    y1: 55.1328,
    x2: 77.8044,
    y2: 77.1208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA51E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461885"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3307_660",
    x1: 26.1832,
    y1: 95.148,
    x2: 26.1832,
    y2: 81.8392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA51E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461885"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3307_660",
    x1: 72.927,
    y1: 64.4147,
    x2: 94.4937,
    y2: 77.0606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#461885"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA51E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3307_660",
    x1: 18.4593,
    y1: 18.6059,
    x2: 65.7446,
    y2: 44.6129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAD4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#77007C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3307_660",
    x1: 32.0901,
    y1: 19.2134,
    x2: 65.1164,
    y2: 37.3778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAD4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#77007C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3307_660",
    x1: 7.34523,
    y1: 18.47,
    x2: 80.8319,
    y2: 18.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAD4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#77007C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/web.73da9dca66b5069571250198b7ce62ea.svg";
export { ForwardRef as ReactComponent };